import axios from "axios";

function apiBase() {
  const env = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const prefix = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    // In locale il backend gira su un'altra porta (es. :8000).
    if (/localhost|127\.0\.0\.1/i.test(origin) && env) {
      return env;
    }
    // In produzione usa l'host della pagina (www e non-www), non un URL hardcoded.
    return `${origin}${prefix}`;
  }

  return env || "http://localhost:8000";
}

const API = `${apiBase()}/api`;

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("sm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  categories: () => http.get("/catalog/categories").then((r) => {
    if (!Array.isArray(r.data)) throw new Error("Catalogo non valido");
    return r.data;
  }),
  catalog: (categoria, q) => http.get("/catalog", { params: { categoria, q } }).then((r) => {
    if (!Array.isArray(r.data)) throw new Error("Catalogo non valido");
    return r.data;
  }),
  product: (id) => http.get(`/catalog/item/${id}`).then((r) => r.data),
  createQuote: (payload) => http.post("/quotes", payload).then((r) => r.data),
  getQuote: (id) => http.get(`/quotes/${id}`).then((r) => r.data),
  updateQuote: (id, payload) => http.put(`/quotes/${id}`, payload).then((r) => r.data),
  pdfUrl: (id) => `${API}/quotes/${id}/pdf`,
  sendPdf: (id) => http.post(`/quotes/${id}/send-pdf`).then((r) => r.data),
  contact: (payload) => http.post("/contact", payload).then((r) => r.data),
  login: (payload) => http.post("/auth/login", payload).then((r) => r.data),
  stats: () => http.get("/admin/stats").then((r) => r.data),
  adminQuotes: (params) => http.get("/admin/quotes", { params }).then((r) => r.data),
  setStatus: (id, stato) => http.put(`/admin/quotes/${id}/status`, { stato }).then((r) => r.data),
  adminContacts: () => http.get("/admin/contacts").then((r) => r.data),
  setContactStatus: (id, stato) => http.put(`/admin/contacts/${id}/status`, { stato }).then((r) => r.data),
  createProduct: (p) => http.post("/admin/products", p).then((r) => r.data),
  updateProduct: (id, p) => http.put(`/admin/products/${id}`, p).then((r) => r.data),
  deleteProduct: (id) => http.delete(`/admin/products/${id}`).then((r) => r.data),
};

export const euro = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);
